import {useData} from "./Calendar";
import {useState} from "react";
import {Button, InputGroup} from "react-bootstrap";
import {Typeahead} from "react-bootstrap-typeahead";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClose, faSearch} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router-dom";

export default function  SearchBuildingEventsBar(props){
    const {shortBuildings} = useData();
    const navigate = useNavigate();
    const [searchBarOpen, setSearchBarOpen] = useState(props.opened || false);

    const handleSelectBuilding = (b)=>{
        if(b.length <=0)
            return;

        const building = b[0];

        navigate(`/calendar/${building.id}`)
    }

    const handleOpeanSearchBar = ()=>{

        setSearchBarOpen(!searchBarOpen);
    }



    return (
        <>

            <InputGroup className="mb-3">
                {
                    searchBarOpen && <>
                        <InputGroup.Text id="search">Szukaj</InputGroup.Text>
                        <Typeahead
                            id="select_building_auto"
                            className={"buildingEventSearchInput"}
                            labelKey="name"
                            onChange={handleSelectBuilding}
                            options={shortBuildings}
                            placeholder="Wybierz obiekt..."
                        />
                    </>
                }

                <Button variant="outline-secondary" id="btnOpenSearchBar" onClick={handleOpeanSearchBar}>
                    {
                        searchBarOpen === true ?
                            <FontAwesomeIcon icon={faClose} />
                            :
                            <FontAwesomeIcon icon={faSearch} />
                    }
                </Button>
            </InputGroup>
         </>
    )
}